import { FC } from 'react'

export const Logo: FC = () => {
  return <img alt="office MAP by TRANCE" src="/logo.svg" />
}
